import { CardActionArea, CardContent } from '@material-ui/core';
import { ColorDynamic, Inline, Stack } from '@superdispatch/ui';
import { SuggestedByShipperTag } from 'shared/modules/load-suggestions/SuggestedByShipperTag';
import { PostingPrivateTag } from 'shared/modules/loadboard/PostingPrivateTag';
import styled from 'styled-components';
import { PostingLoadEventObserver } from '../../core/PostingLoadEventObserver';
import { PostingAvailableDate } from '../../core/postings/PostingAvailableDate';
import { PostingHiddenShipperTooltip } from '../../core/postings/PostingHiddenShipperTooltip';
import { PostingVehicle } from '../../core/postings/PostingVehicle';
import { PostingVehiclesSummary } from '../../core/postings/PostingVehiclesSummary';
import { PostingWaypoints } from '../../core/postings/PostingWaypoints';
import { ShipperCompanyName } from '../../core/postings/ShipperCompanyName';
import { PostingDTO, getPostingState } from '../../data/dto/PostingDTO';
import { PostingPaymentDetails } from '../PostingPaymentDetails';
import { PostingPriceLabel } from '../PostingPriceLabel';

const Wrapper = styled(CardActionArea)`
  width: 300px;

  border-width: 1px;
  border-radius: 4px;
  border-color: ${ColorDynamic.Silver400};
  background-color: ${ColorDynamic.White};

  scroll-snap-align: center;
`;

interface SuggestedLoadCardProps {
  posting: PostingDTO;
  onClick: () => void;
}

export function SuggestedLoadCard({
  onClick,
  posting,
}: SuggestedLoadCardProps) {
  const { load } = posting;
  const postingStatus = getPostingState(load, null);

  return (
    <PostingLoadEventObserver posting={posting}>
      {(ref) => (
        <Wrapper
          ref={ref}
          data-cy="LoadCard"
          data-testid="LoadCard"
          onClick={onClick}
        >
          <CardContent>
            <Stack>
              {posting.is_shipper_recommended && <SuggestedByShipperTag />}

              <Inline space="xsmall">
                <PostingPriceLabel
                  load={load}
                  isBookable={postingStatus === 'can_book'}
                />
                {load.is_posted_to_private_loadboard && <PostingPrivateTag />}
              </Inline>

              <PostingPaymentDetails load={load} source="Suggested Load" />

              <PostingWaypoints load={load} />

              {load.vehicles.length > 0 &&
                (load.vehicles.length === 1 && load.vehicles[0] ? (
                  <PostingVehicle
                    vehicle={load.vehicles[0]}
                    transportType={load.transport_type}
                    hideVehicleInfo={!!load.hide_vehicle_info}
                  />
                ) : (
                  <PostingVehiclesSummary
                    vehicles={load.vehicles}
                    transportType={load.transport_type}
                    title={`${load.vehicles.length} Vehicles`}
                    hideVehicleInfo={!!load.hide_vehicle_info}
                  />
                ))}

              {load.shipper ? (
                <ShipperCompanyName shipper={load.shipper} />
              ) : (
                <PostingHiddenShipperTooltip />
              )}

              <PostingAvailableDate {...load} />
            </Stack>
          </CardContent>
        </Wrapper>
      )}
    </PostingLoadEventObserver>
  );
}
